import { axiosInstance as request } from '@api/rest.service'

const api = '/subscribers'

/**
 * @description POST /subscribers
 * @param payload {{ user_ids: number[], entity_id: number, entity: string }}
 * @returns {AxiosPromise<any>}
 */
export const SUBSCRIBE = payload => request.post(api, payload)
